import Link from 'next/link'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface WelcomeData {
    titleSpan?: string
    title: string
    description: string
    btn: {
        content: string
        link: string
    }
    btn2: {
        content: string
        link: string
        onClick?: ()=>void
    }
}

interface Props {
    data: WelcomeData,
    onClickSecond?: ()=>any 
}

const MainWelcome: React.FC<Props> = ({ data, onClickSecond }) => {
    return (
        <div className='main__welcome'>
            {/* <Image className='main__welcome-bg' src={mapImage} width={1302} height={841} alt='map-img' /> */}

            {data.titleSpan ? (
                <h1 className='main__welcome-title'>
                    <span>{data.titleSpan}</span> <br />
                    {data.title}
                </h1>
            ) : (
                <h1 className='main__welcome-title'>{data.title}</h1>
            )}
            <p className='main__welcome-description'>{data.description}</p>
            <div className='main-about__card-buttons'>
                {data.btn.link === '/' ? (
                    <a href='/'>
                        <button className='main-about__card-button main__card-button know-more'>
                            <p>{data.btn.content}</p>
                        </button>
                    </a>
                ) : (
                    <Link href={data.btn.link}>
                        <button className='main-about__card-button main__card-button know-more'>
                            <p>{data.btn.content}</p>
                        </button>
                    </Link>
                )}
                {
                    onClickSecond ? 
                        <button className='main-about__card-button main__card-button' onClick={onClickSecond}>
                            <p>{data.btn2.content}</p>
                        </button>
                    : 
                    <Link href={data.btn2.link}>
                        <button className='main-about__card-button main__card-button'>
                            <p>{data.btn2.content}</p>
                        </button>
                    </Link>
                }
            </div>
        </div>
    )
}

export default MainWelcome
